import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./dev.css";
import "react-toastify/dist/ReactToastify.css";
import 'react-intl-tel-input-18/dist/main.css';
import reportWebVitals from "./reportWebVitals";
import { Loader } from "./components";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const loader = ReactDOM.createRoot(
	document.getElementById("loader") as HTMLElement
);
loader.render(
	<React.StrictMode>
		<Loader />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
